import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store';
import CookieJar from '@/utilities/cookieJar';

const routes = [
  {
    path: '/',
    redirect: { name: 'Register' }
  },
  {
    path: '/login',
    component: () => import('../pages/login.vue'),
    name: 'Login'
  },
  {
    path: '/register',
    component: () => import('../pages/register.vue'),
    name: 'Register'
  },
  {
    path: '/verification-check/:checkType',
    component: () => import('../pages/verification-check.vue'),
    props: true,
    name: 'VerificationCheck'
  },
  {
    path: '/verify',
    component: () => import('../pages/verify.vue'),
    name: 'VerifyUser'
  },
  {
    path: '/resend-verification',
    component: () => import('../pages/resend-verification.vue'),
    name: 'ResendVerification'
  },
  {
    path: '/dashboard',
    component: () => import('../pages/dashboard.vue'),
    name: 'Dashboard',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/stage-one',
    component: () => import('../pages/stage.vue'),
    name: 'StageOne',
    redirect: { name: 'ContactDetailsEOI' },
    meta: {
      applicationType: 'eoi',
      steps: 'stageOneSteps',
      stageName: 'Expression of Interest Application',
      confirmationPage: 'EOIConfirmation',
      requiresAuth: true
    },
    children: [
      {
        path: 'contact-details',
        component: () => import('../pages/stage-one/contact-details.vue'),
        name: 'ContactDetailsEOI',
        meta: {
          requiresAuth: true,
          requiresEOI: true
        }
      },
      {
        path: 'business-location',
        component: () => import('../pages/stage-one/business-location.vue'),
        name: 'BusinessLocation',
        meta: {
          requiresAuth: true,
          requiresEOI: true
        }
      },
      {
        path: 'business-details',
        component: () => import('../pages/stage-one/business-details.vue'),
        name: 'BusinessDetailsEOI',
        meta: {
          requiresAuth: true,
          requiresEOI: true
        }
      },
      {
        path: 'declarations',
        component: () => import('../pages/stage-one/declarations.vue'),
        name: 'DeclarationsEOI',
        meta: {
          requiresAuth: true,
          requiresEOI: true
        }
      }
    ]
  },
  {
    path: '/stage-two',
    component: () => import('../pages/stage.vue'),
    name: 'StageTwo',
    redirect: { name: 'CreditSafeDeclaration' },
    meta: {
      applicationType: 'application',
      steps: 'stageTwoSteps',
      stageName: 'Application',
      confirmationPage: 'ApplicationConfirmation',
      requiresAuth: true,
      requiresApplication: true
    },
    children: [
      {
        path: 'creditsafe-declaration',
        component: () => import('../pages/stage-two/creditsafe-declaration.vue'),
        name: 'CreditSafeDeclaration',
        meta: {
          requiresAuth: true,
          requiresApplication: true
        }
      },
      {
        path: 'business-details',
        component: () => import('../pages/stage-two/business-details.vue'),
        name: 'BusinessDetails',
        meta: {
          requiresAuth: true,
          requiresApplication: true
        }
      },
      {
        path: 'contact-details',
        component: () => import('../pages/stage-two/contact-details.vue'),
        name: 'ContactDetails',
        meta: {
          requiresAuth: true,
          requiresApplication: true
         }
      },
      {
        path: 'directors',
        component: () => import('../pages/stage-two/directors.vue'),
        name: 'Directors',
        meta: {
          requiresAuth: true,
          requiresApplication: true
         }
      },
      {
        path: 'shareholders',
        component: () => import('../pages/stage-two/shareholders.vue'),
        name: 'Shareholders',
        meta: {
          requiresAuth: true,
          requiresApplication: true
         }
      },
      {
        path: 'project-details-one',
        component: () => import('../pages/stage-two/project-details-1.vue'),
        name: 'ProjectDetailsOne',
        meta: {
         requiresAuth: true,
         requiresApplication: true
         }
      },
      {
        path: 'project-details-two',
        component: () => import('../pages/stage-two/project-details-2.vue'),
        name: 'ProjectDetailsTwo',
        meta: {
         requiresAuth: true,
         requiresApplication: true
         }
      },
      {
        path: 'market-information',
        component: () => import('../pages/stage-two/market-information.vue'),
        name: 'MarketInformation',
        meta: {
         requiresAuth: true,
         requiresApplication: true
         }
      },
      {
        path: 'project-impacts',
        component: () => import('../pages/stage-two/project-impacts.vue'),
        name: 'ProjectImpacts',
        meta: {
         requiresAuth: true,
         requiresApplication: true
         }
      },
      {
        path: 'payment-details',
        component: () => import('../pages/stage-two/payment-details.vue'),
        name: 'PaymentDetails',
        meta: {
          requiresAuth: true,
          requiresApplication: true
         }
      },
      {
        path: 'additional-documents',
        component: () => import('../pages/stage-two/additional-documents.vue'),
        name: 'AdditionalDocuments',
        meta: {
          requiresAuth: true,
          requiresApplication: true
         }
      },
      {
        path: 'declarations',
        component: () => import('../pages/stage-two/declarations.vue'),
        name: 'Declarations',
        meta: {
          requiresAuth: true,
          requiresApplication: true
         }
      }
    ]
  },
  {
    path: '/stage-one/confirmation',
    component: () => import('../pages/eoi-confirmation.vue'),
    name: 'EOIConfirmation',
    meta: {
      requiresAuth: true
     }
  },
  {
    path: '/stage-two/confirmation',
    component: () => import('../pages/application-confirmation.vue'),
    name: 'ApplicationConfirmation',
    meta: {
      requiresAuth: true
     }
  },
  {
    path: '/claim',
    component: () => import('../pages/stage.vue'),
    name: 'Claim',
    redirect: { name: 'ClaimDetails' },
    meta: {
      applicationType: 'claim',
      steps: 'claimSteps',
      stageName: 'Claim',
      confirmationPage: 'ClaimConfirmation',
      requiresAuth: true
    },
    children: [
      {
        path: 'claim-details/:claimId',
        component: () => import('../pages/claim/claim-details.vue'),
        name: 'ClaimDetails',
        meta: {
          requiresAuth: true,
          requiresClaims: true
        }
      }
    ]
  },
  {
    path: '/claim/confirmation',
    component: () => import('../pages/claim-confirmation.vue'),
    name: 'ClaimConfirmation',
    meta: {
      requiresAuth: true
     }
  },
  {
    path: '/documents/:stage',
    component: () => import('../pages/document-management.vue'),
    name: 'DocumentManagement',
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/close-down',
    name: 'CloseDown',
    component: () => import('../pages/close-down.vue')
  },
  {
    path: '/error',
    name: 'Error',
    component: () => import('../pages/server-error.vue')
  },
  {
    path: '/faq',
    name: 'faq',
    component: () => import('../pages/faq.vue')
  },
  {
    path: '/forgot-password',
    name: 'forgotPassword',
    component: () => import('../pages/forgot-password.vue')
  },
  {
    path: '/reset-password',
    name: 'resetPassword',
    component: () => import('../pages/reset-password.vue'),
    beforeEnter: (to, from) => {
      if (!to.query.token || !to.query.email) {
        router.push({ name: 'Login' });
      }
    }
  },
  {
    path: '/:catchAll(.*)',
    name: 'Error',
    component: () => import('../pages/not-found.vue')
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresEOI) && !store.getters['settings/getEoiDownloaded']) {
    router.push({ name: 'Dashboard' });
  } else if (to.matched.some(record => record.meta.requiresApplication) && !store.getters['settings/getAppDownloaded']) {
    router.push({ name: 'Dashboard' });
  } else if (to.matched.some(record => record.meta.requiresClaims) && !store.getters['settings/getClaimsDownloaded']) {
    router.push({ name: 'Dashboard' });
  } else {
    next();
  }
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters['auth/isAuthenticated']) {
      next();
    } else {
      // nothing in the store, so lets check cookies
      const accessToken = CookieJar.get(`${process.env.VUE_APP_COOKIE_PREFIX}access_token`);
      const refreshToken = CookieJar.get(`${process.env.VUE_APP_COOKIE_PREFIX}refresh_token`);
      if (!accessToken) {
        // access token is invalid, lets check the refresh token
        if (!refreshToken) {
          // no valid tokens, redirect to login
          next({ name: 'Login' });
        } else {
          store.dispatch('auth/redeemToken', {
            refreshtoken: refreshToken,
            businessunit: process.env.VUE_APP_BUSINESS_UNIT
          }).then(() => {
            next();
          }).catch(() => {
            next({ name: 'Login' });
          });
        }
      } else {
        store.dispatch('auth/updateAuth', {
          accessToken,
          refreshToken
        }).then(() => {
          next();
        });
      }
    }
  } else {
    next();
  }
});

export default router;
